import './modal-gallery-v2';

/**
 * This class is used with Amenities widget
 */
class Amenities {

    /**
     * Getter for endpoint used to post user action click for Amenities
     * @returns full path to the endpoint
     */
    static GET_AMENITIES_ENDPOINT() { return  "/api/widgets/amenitieswidget/getamenities" }
    /**
     * @param moduleSelector jQuery selector 
     */
    constructor(moduleSelector) {
        this.moduleElem = $(moduleSelector);
        this.viewMoreButtonElem = this.moduleElem.find("#view_more_btn");
        this.amenitiesDivElem = this.moduleElem.find("#amenities-view-more");
        this.pageCounter = 1;
    }

    /**
     * Get request to fetch the data for amenities 
     * @returns Promise
     */
    getAmenities()
    {
        let _this = this;
        return new Promise(function(resolve, reject)
        {
            try
            {
                // Get Anti-CSRF token
                let csrfToken = _this.moduleElem.find('[name="__RequestVerificationToken"]').val();
                let endpointUrl = Amenities.GET_AMENITIES_ENDPOINT();
                let contentPath = _this.moduleElem.find('#amenities-contentpath').val();
                let data = { page: _this.pageCounter, contentPath: contentPath };
                $.ajax({
                    type: "GET",
                    url: endpointUrl,
                    data: data,
                    cache: false,
                    dataType: "html",
                    beforeSend: function (request) {
                        if (csrfToken) {
                            request.setRequestHeader("__RequestVerificationToken", csrfToken);
                        }
                        window.showPreLoader();
                    },
                    success: function (response) {
                        if ((response!=null))
                        {
                            if (resolve) resolve(response);
                            let amenityCards = _this.moduleElem.find('#amenity-cards');
                            amenityCards.empty();

                            // Append the HTML code to a div element with the given ID
                            _this.moduleElem.find("#amenity-cards").append(response);

                            // lazy load images
                            lozadObserver();
                            // init carousels in modals found in the card section
                            initMediaWithThumbnailCarousels(document.getElementById("amenity-cards"));
                            // re-init the reveal modal for image and video gallery
                            window.Foundation.reflow($(".media-modal"), 'reveal');
                            window.Foundation.reflow($(".media-modal"), 'reveal');
                            lozadObserver();

                            let amenitiesHasMorePage = _this.moduleElem.find('#AmenitiesHasMorePage').val(); 
                            //check and hide if there is no data available to view more amenities.
                            if(amenitiesHasMorePage!="1"){
                                _this.amenitiesDivElem.remove();
                            }
                        }
                        else {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                })
            }
            catch (err)
            {
                if (reject) reject("Error occurred accepting investor terms:" + err);
            }
        });
    }    

    
    /**
     * Initialize the view more button instance 
     */
    init() {
        this.viewMoreButtonElem.on("click", (event) => this.onViewMoreButtonClick(event));
        window.initModalCarouselV2();
        lozadObserver();
    }

    /**
     * Event Handler for click of view more amenities button
     * @param {jQuery Event} e event object
     */
    onViewMoreButtonClick(e)
    {
        // Increment of page counter on every view more clicked
        this.pageCounter++;
        e.preventDefault();
        this.getAmenities().then((response) => {
            window.hidePreLoader();
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            window.hidePreLoader();
        });
    }
}

window.Amenities = Amenities;